import { useState } from "react";
import { useSearchParams } from "react-router-dom";

import { getEntityName } from "../UnifiedRegistry/utils";

import ChangelogContent from "./ChangelogContent";
import { ChangelogFilterState } from "./FilterBar";
import { ChangelogProps } from "./types";

import { useGetChangelog } from "@/queries";

const ChangelogHeader = () => (
  <div className="mb-4">
    <h2 className="text-xl font-semibold">Changelog</h2>
    <p className="mt-1 text-sm text-gray-500">Track version updates and label changes</p>
  </div>
);

const Changelog = ({ entity }: ChangelogProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const scrollToId = searchParams.get("scrollTo");

  const [filters, setFilters] = useState<ChangelogFilterState>({
    selectedDateRange: null,
    selectedUserId: null,
    showPendingOnly: false,
  });

  const { data, isLoading, error, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useGetChangelog({
      entity_id: entity.id,
      entity_type: entity.type,
      start_date: filters.selectedDateRange?.start,
      end_date: filters.selectedDateRange?.end,
      user_id: filters.selectedUserId ?? undefined,
      pending: filters.showPendingOnly ? true : undefined,
    });

  const { data: pendingData } = useGetChangelog({
    entity_id: entity.id,
    entity_type: entity.type,
    pending: true,
    per_page: 1,
  });

  const handleClearScrollTo = () => {
    searchParams.delete("scrollTo");
    setSearchParams(searchParams, { replace: true });
  };

  const emptyStateMessage = `Changelog events are tracked for new activities. Legacy ${getEntityName(entity.type).toLowerCase()}s may not have historical events recorded.`;

  return (
    <div className="mx-auto w-full py-2">
      <ChangelogHeader />
      <ChangelogContent
        data={data}
        pendingData={pendingData}
        isLoading={isLoading}
        error={error}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        filters={filters}
        onFiltersChange={setFilters}
        emptyStateMessage={emptyStateMessage}
        scrollToId={scrollToId}
        onClearScrollTo={handleClearScrollTo}
      />
    </div>
  );
};

export default Changelog;
